import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TpEmailBuilderModule } from '../tp-email-builder/tp-email-builder.module';
import { TpEmailSimpleModule } from '../tp-email-simple/tp-email-simple.module';
import { TpMergeTagChipsModule } from '../tp-merge-tag-chips/tp-merge-tag-chips.module';
import { TpToggleModule } from '../tp-toggle/tp-toggle.module';
import { TpEmailComposerComponent } from './tp-email-composer.component';

@NgModule({
    declarations: [TpEmailComposerComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TpEmailBuilderModule,
        TpEmailSimpleModule,
        TpMergeTagChipsModule,
        TpToggleModule,
    ],
    exports: [TpEmailComposerComponent],
})
export class TpEmailComposerModule {}
